import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import Paper from "@material-ui/core/Paper";
import { Formik, Form } from "formik";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import SearchIcon from "@material-ui/icons/Search";
import FilerIcon from "@material-ui/icons/FilterList";
import ClearIcon from "@material-ui/icons/Clear";
import { useTranslation } from "react-i18next";

import FormikControl from "components/FormikControl/FormikControl";
import useStyles from "assets/jss/material-dashboard-react/components/customFilterStyle";


const Filter = (props) => {
  const { t } = useTranslation();
  const {
    initialValues,
    filterFields,
    validationSchema,
    onSubmit,
    onClear = () => { },
    noClearButton,
    noSearchButton,
    generateReport,
  } = props;

  const classes = useStyles();

  const [clear, setClear] = useState(false);
  const [showPrompt, setShowPrompt] = useState(false);

  const clearState = () => {
    localStorage.removeItem("status");
    setClear(true);
    //window.location.reload();
    onClear();
  };

  let finalFields = [];
  const showDefaultValue = () => {
    filterFields.forEach((field) => {
      let newField = field;
      if (field.showDefault) {
        newField = {
          ...field,
          value: field.value,
        };
      }
      finalFields.push(newField);
    });
  };
  showDefaultValue();

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      onClear={onClear}
      validationSchema={validationSchema ? validationSchema : null}
    >
      {(formik) => {
        const areAllFieldsEmpty = Object.values(formik.values).every(
          (value) => !value
        );

        return (
          <Form>
            <Grid container>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Paper className={classes.filterPaper} variant="outlined">
                  <Grid container spacing={3}>
                    {finalFields.map((field) => {
                      const {
                        type,
                        name,
                        label,
                        value,
                        options,
                        ...rest
                      } = field;
                      return (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={6}
                          lg={3}
                          key={field.name}
                        >
                          {field.value ? (
                            <FormikControl
                              control={type}
                              name={name}
                              label={t(label)}
                              value={value}
                              options={options}
                              size="small"
                              clear={clear}
                              setClear={setClear}
                              {...rest}
                            />
                          ) : (
                            <FormikControl
                              control={type}
                              name={name}
                              label={t(label)}
                              options={options}
                              size="small"
                              clear={clear}
                              setClear={setClear}
                              {...rest}
                            />
                          )}
                        </Grid>
                      );
                    })}
                  </Grid>
                  <div className={classes.toolbar} />
                  <Grid container spacing={2}>
                    <Grid item>
                      {noSearchButton ? null : (

                        <Button
                          type="button"
                          className={classes.searchButton}
                          startIcon={<SearchIcon />}
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            if (areAllFieldsEmpty) {
                              setShowPrompt(true);
                            } else {
                              setShowPrompt(false);
                              formik.handleSubmit();
                            }
                          }}
                        >
                          {t("Search")}
                        </Button>
                      )}

                      {generateReport ?

                        <Button
                          type="button"
                          className={classes.searchButton}
                          startIcon={<FilerIcon />}
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            if (areAllFieldsEmpty) {
                              setShowPrompt(true);
                            } else {
                              setShowPrompt(false);
                              formik.handleSubmit();
                            }
                          }}
                        >
                          {t("Generate Report")}
                        </Button>
                        : null}


                    </Grid>
                    {noClearButton ? null : (
                      <Grid item>
                        <Button
                          className={classes.clearFilter}
                          startIcon={<ClearIcon />}
                          onClick={() => {
                            clearState();
                            formik.resetForm();
                            setShowPrompt(false);
                            formik.handleSubmit();

                          }}
                        >
                          {t("Clear Filter")}
                        </Button>
                      </Grid>
                    )}
                  </Grid>
                  {showPrompt && (
                    <div className={classes.prompt} style={{ color: 'red' }}>
                      <br />
                      Please choose at least 1 criteria to search.
                    </div>
                  )}
                </Paper>
              </Grid>
            </Grid>
          </Form>
        );
      }}
    </Formik>
  );
};

Filter.propTypes = {
  onSubmit: PropTypes.func,
  onClear: PropTypes.func,
  filterFields: PropTypes.array,
  initialValues: PropTypes.object,
  noClearButton: PropTypes.bool,
  noSearchButton: PropTypes.bool,
  generateReport: PropTypes.bool,
  formik: PropTypes.object,
  validationSchema: PropTypes.object,
};

export default Filter;
